// src/pages/ContactConfirmation.jsx
import React from "react";
import { useLocation, Link } from "react-router-dom";
import Footer from "../../components/homepage/Footer";

export default function ContactConfirmation() {
  const { state } = useLocation();

  return (
    <>
    <div className="min-h-screen flex flex-col justify-center items-center text-center px-6 pt-20">
      <div className="bg-black/60 border border-neonTurquoise rounded-2xl p-10 max-w-xl w-full backdrop-blur-md shadow-xl">
        <h1 className="text-neonTurquoise text-4xl font-bold mb-4">
          Message Sent
        </h1>
        <p className="text-gray-300 text-lg mb-6">
          Thank you, {state?.name}. We received your message and will contact
          you at{" "}
          <span className="text-white font-semibold">{state?.email}</span>.
        </p>

        <Link
          to="/"
          className="text-white bg-neonTurquoise px-6 py-3 rounded-lg font-semibold hover:scale-105 transition"
        >
          Return Home
        </Link>
      </div>
    </div>
    <Footer />
    </>
  );
}
